module.exports = __webpack_public_path__ + "img/T6-C-xh_9.97bf6acb.png";